import React from 'react';
import './styles.css';

const BasicControlGroup = props => {
  const { groupStyles } = props;
  return (
    <div className="basic-control-group" style={groupStyles}>
      {props.children.length > 1 ? (
        props.children.map((control, index) => {
          return (
            control && (
              <div className="basic-control-group__control" key={index}>
                {control}
              </div>
            )
          );
        })
      ) : (
        <div className="basic-control-group__control">{props.children}</div>
      )}
    </div>
  );
};

export default BasicControlGroup;
